import * as THREE from 'three';
import { PlanogramRendererResources } from './Resources.js';
import { PlanogramObject } from './PlanogramObject.js';

export class DragArray extends THREE.InstancedMesh {
    actualPosition = new THREE.Vector3();
    /**@type {PlanogramObject} */
    target = null;
    /**@type {PlanogramObject[]} */
    planogramObjects = [];
    /**@type {THREE.Box3[]} */
    boxes = [];
    /**@type {AnchorData} */
    anchorData = null;

    get targetInstance(){
        return this.planogramObjects.indexOf(this.target);
    }

    get targetBox(){
        return this.boxes[this.targetInstance];
    }
    /**
     * 
     * @param {PlanogramObject} target 
     * @param {PlanogramObject[]} planogramObjects 
     * @param {DataTransfer} dataTransfer
     */
    constructor( target, planogramObjects, dataTransfer ) {
        super( new THREE.BoxGeometry(1,1,1), PlanogramRendererResources.DragShader, planogramObjects.length );
        this.planogramObjects = planogramObjects;
        this.target = target;
        this.layers.set(PlanogramRendererResources.DRAG_LAYER);
        this.dataTransfer = dataTransfer;
        this.focusCentre = new THREE.Vector3( target.x, target.y, target.z);
        this.boxes = planogramObjects.filter(x=> x !== null).map( planogramObject => planogramObject.groupBoundingBox.translate( new THREE.Vector3(planogramObject.x, planogramObject.y, planogramObject.z ).sub(this.focusCentre)) );
        this.name = "dragArray";
        this.boxes.forEach((inst, i) => {
            const size = inst.getSize(new THREE.Vector3());
            const centre = inst.getCenter(new THREE.Vector3());
            const matrix = new THREE.Matrix4().makeTranslation(centre.x, centre.y, centre.z)
                .multiply(new THREE.Matrix4().makeScale(size.x, size.y, size.z));
            this.setMatrixAt(i, matrix);
        });
        var sizeArray = new Float32Array( this.boxes.flatMap( x => x.getSize(new THREE.Vector3()).toArray() ) );
        this.geometry.setAttribute( "size", new THREE.InstancedBufferAttribute( sizeArray , 3 ));

    }

    dropDragArray( raiseEvent = false ){
        this.removeFromParent();
        this.dispose();

        if(this.anchorData){
            this.anchorData.target.raisePositionAnchoredEvent(this.anchorData.normal);
        }else{
            const oldPosition = this.focusCentre.clone();
            const newPosition = this.position.clone();
            if( this.dataTransfer && raiseEvent )this.target.raiseDropEvent( oldPosition, newPosition, this.dataTransfer );
        }
    }
    

}

export class AnchorData{

    /**@type {PlanogramObject} */
    target = null;
    /**@type {THREE.Vector3} */
    normal = null;
    /**
     * 
     * @param {THREE.Vector3} normal 
     * @param {PlanogramObject} target 
     */
    constructor( normal, target ){
        this.normal = normal;
        this.target = target;
    }
}

export class SnapDecoration extends THREE.Mesh{
    /**
     * 
     * @param {THREE.Box3} box 
     * @param {THREE.Vector3} normal 
     */
    constructor( box, normal ){
        super( new THREE.PlaneGeometry(1,1), PlanogramRendererResources.DecoratorShader );
        this.layers.set(PlanogramRendererResources.DRAG_LAYER);
        this.renderOrder = 999;
        const size = box.getSize( new THREE.Vector3() );
        const centre = box.getCenter( new THREE.Vector3() );
        var faceSize = new THREE.Vector2( normal.getComponent(0) ? size.z: size.x, 
            normal.getComponent(1) ? size.z: size.y);

        // faceSize = faceSize.multiplyScalar(1.05);
        this.scale.set(faceSize.x, faceSize.y, 1);
        const actualPosition = centre.clone().add(normal.clone().multiply(size.clone().multiplyScalar(0.5)));
        const quaternion = new THREE.Quaternion().setFromUnitVectors(new THREE.Vector3(0, 0, 1), normal);

        this.geometry.setAttribute( "size", new THREE.Float32BufferAttribute( 
            Array(8).fill(new THREE.Vector2( faceSize.x, faceSize.y ).toArray()).flat(), 2 ) );

        this.position.copy(actualPosition);
        this.setRotationFromQuaternion(quaternion);

    }
}